import React from "react";
import BtnClose from "../../assets/images/btn-close.svg";
import "./helpdeskPopup.scss";

export const HelpdeskPopup = (props) => {
  return (
    <div
      className={
        props.helpdeskToggle ? "helpdesk-popup active" : "helpdesk-popup"
      }
    >
      <div className="helpdesk-sec">
        <button type="button" className="close" onClick={props.helpdeskHandler}>
          <img src={BtnClose} alt="" />
        </button>

        <h2 className="title">Help Desk / Soror Services</h2>
        <div className="row flex">
          <div className="colm">
            <div className="inner">
              <p className="helpText">
                Need assistance accessing the <strong>Lobby & Exibit Hall?</strong> Contact us, live help is available 8:00 AM - 10:00 PM.
              </p>
              <a
                className="btn btn-green"
                target="_blank"
                href="https://www.aka1908.com/help"
              >
                LIVE CHAT
              </a>
              {/* <p>
                Need assistance accessing
                <br /> the <b>Lobby & Exhibit Hall?</b>
                <br />
                Click "Info Desk" link in the Exhibit Hall.
                <br /> Contact us, live help is available
                <br /> 8:00 AM – 10:00 PM.
              </p> */}
              {/* {props.vfairUrl ? (
                <a
                  className="btn btn-green"
                  target="_blank"
                  href={props.vfairUrl ? props.vfairUrl : "#"}
                >
                  LIVE CHAT
                </a>
              ) : null} */}
            </div>
          </div>
          {/* <div className="colm">
            <div className="inner">
              <p>
                Have a question about
                <br /> the <b>Auditorium & Convention Center</b> <br />
                platform or need assistance accessing events? <br />
                Contact us, live help is available
                <br /> 8:00 AM – 10:00 PM.
              </p>
              {props.vfairUrl ? (
                <a
                  className="btn btn-green"
                  href="https://app.hopin.com/events/69th-boule-part-ii-2021-leadership-seminar/expo/549456"
                  target="_blank"
                >
                  LIVE CHAT
                </a>
              ) : null}
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};
